import React from 'react';

import ProposalPreview from '../proposalPreview';

const Container = () => <ProposalPreview.Container fromQuote />;

export default Container;
